import React from 'react';
import { TIPS } from 'types/morph.pagePosition.constants';
import { StandardCreditCardOffer } from 'components/Offers/StandardCreditCardOffer/StandardCreditCardOffer';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';

const CreditAgeView = props => {
  return (
    <>
      {props.seenPixel}
      <div>
        <div>
          <StaticOfferContainer
            offerMetadataList={props.offers}
            eventHandler={props.eventHandler}
            pagePosition={TIPS}
            modulePosition={props.extraAttributes.modulePosition}
            creditCardTemplate={StandardCreditCardOffer}
            partnersCustomTrackingMeta={props.partnersCustomTrackingMeta}
          />
        </div>
      </div>
    </>
  );
};
const CreditAgeController = props => {
  const atr = getViewModuleTrackingAttributes(
    TIPS,
    props.extraAttributes.modulePosition,
  );
  const seenPixel = useSeenModulePixel(atr);
  return (
    <CreditAgeView
      {...props}
      offers={props.offers ? props.offers : []}
      seenPixel={seenPixel}
    />
  );
};

export default CreditAgeController;
